/**
 * Inside the Desktop platform shell the shell's RU/EN switch is the one switch
 * (owner, 19.10): Bunker hides its own and follows the shell's language live —
 * no reload, a reload would drop a call. Desktop passes the language on through
 * the preload bridge (`onPlatformLanguage`). A no-op everywhere else.
 */
export function followDesktopLanguage(
  bridge: Window['bunkerDesktop'],
  changeLanguage: (language: 'ru' | 'en') => void,
): (() => void) | null {
  if (!bridge?.platformShell || typeof bridge.onPlatformLanguage !== 'function') return null;
  return bridge.onPlatformLanguage((language) => {
    if (language === 'ru' || language === 'en') changeLanguage(language);
  });
}
